import { render, staticRenderFns } from "./LogOperacao.vue?vue&type=template&id=90e3dd24&"
import script from "./LogOperacao.vue?vue&type=script&lang=js&"
export * from "./LogOperacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports